var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubmitIcons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_25708",
    "data-name": "Group 25708",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.52,
    height: 19.999,
    viewBox: "0 0 20.52 19.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_36685",
    "data-name": "Path 36685",
    d: "M20.3,15.258a2.15,2.15,0,0,0-1-1L3.087,6.412A2.15,2.15,0,0,0,.154,9.146l2.82,7.05-2.82,7.05a2.15,2.15,0,0,0,2.933,2.735L19.306,18.13A2.15,2.15,0,0,0,20.3,15.258ZM2.463,24.689a.717.717,0,0,1-.977-.911l2.746-6.865h14.3Zm1.769-9.21L1.485,8.613A.716.716,0,0,1,2.463,7.7l16.072,7.775Z",
    transform: "translate(0 -6.197)",
    fill: "#23b5d3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitIcons);
export default __webpack_public_path__ + "static/media/submit_icons.3ac9b75fb969542e153429b0ad20fddf.svg";
export { ForwardRef as ReactComponent };